module.exports = __webpack_public_path__ + "static/img/OIP1.4e90e62.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/OIP1.webp
// module id = nqS3
// module chunks = 0